// extracted by mini-css-extract-plugin
export default {"menuList":"menu_menuList__o3vY1","menuItem":"menu_menuItem__PjNiy"};